export const PRIMARY_TYPE = "Primary";
export const EMERGENCY_TYPE = "Emergency";
export const SIMPLE_TYPE = "Additional";

export const CONTACT_MAX_DATE_OF_BIRTH = `${(new Date().getFullYear() - 18)}-01-01`;

export const isContactPrimary = (contactType) => contactType === PRIMARY_TYPE;
export const isContactEmergency = (contactType) => contactType === EMERGENCY_TYPE;

export const getContactTitleKey = (contactType) => {
    if (isContactPrimary(contactType)) return "responsibleAdults.primaryContact";
    if (isContactEmergency(contactType)) return "responsibleAdults.emergencyContact";
    return "responsibleAdults.contact";
};
